import React from "react";

const ExclamationSmallIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="3.322" height="12.37" viewBox="0 0 2.322 10.37">
  <path id="Caminho_2337" data-name="Caminho 2337" d="M7.661,3.261c-.661,0-1.161.345-1.161.9V9.274c0,.558.5.9,1.161.9.645,0,1.161-.358,1.161-.9V4.163C8.822,3.619,8.306,3.261,7.661,3.261Zm0,8.066a1.152,1.152,0,1,0,1.151,1.152A1.154,1.154,0,0,0,7.661,11.326Z" transform="translate(-6.5 -3.261)" fill="#e2574c"/>
</svg>
);
export default ExclamationSmallIcon;
